import { render } from "./Guarantee.vue?vue&type=template&id=5f4c2ccd&lang=pug"
import script from "./Guarantee.vue?vue&type=script&lang=js"
export * from "./Guarantee.vue?vue&type=script&lang=js"

import exportComponent from "/builds/chiedocover/chiedohome.com/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__